import React, { Component } from "react";

import AxiomLayout from "__AxiomComponents/AxiomLayout/AxiomLayout.jsx";
import HawkeyeV2 from "../components/HawkeyeV2/HawkeyeV2";

function Container(props) {
  return (
    <AxiomLayout appName={props.appName} appID={props.appID} componentID="0" layoutName="AxiomApp">
      <HawkeyeV2 appName={props.appName} appID={props.appID} componentID="0" />
    </AxiomLayout>
  );
}

export default Container;
